import React from "react";
import Hero from "@/components/landing/Hero";
import Authority from "@/components/landing/Authority";
import Community from "@/components/landing/Community";
import Gallery from "@/components/landing/Gallery";
import ForWhom from "@/components/landing/ForWhom";
import Experience from "@/components/landing/Experience";
import Speakers from "@/components/landing/Speakers";
import Location from "@/components/landing/Location";
import Mastermind from "@/components/landing/Mastermind";
import Pricing from "@/components/landing/Pricing";
import Urgency from "@/components/landing/Urgency";
import Founder from "@/components/landing/Founder";
import FAQ from "@/components/landing/FAQ";
import InfoForm from "@/components/landing/InfoForm";
import Closing from "@/components/landing/Closing";
import Footer from "@/components/landing/Footer";
import MobileCTA from "@/components/landing/MobileCTA";
import Marquee from "@/components/landing/Marquee";
import SmoothScroll from "@/components/landing/SmoothScroll";
import { MotionConfig } from "framer-motion";
import { ImagesProvider } from "@/lib/ImagesContext";
import { ReservationProvider } from "@/components/landing/ReservationModal";

export default function Landing() {
  return (
    <ImagesProvider>
      <ReservationProvider>
      <MotionConfig reducedMotion="user">
        <main data-testid="landing-root" className="bg-[#FAF8F3] text-[#3F403A]">
          <SmoothScroll />
          <Hero />
          <Marquee />
          <Authority />
          <Community />
          <Gallery />
          <ForWhom />
          <Experience />
          <Speakers />
          <Location />
          <Mastermind />
          <Pricing />
          <Urgency />
          <Founder />
          <FAQ />
          <InfoForm />
          <Closing />
          <Footer />
          <MobileCTA />
          {/* Spacer so fixed mobile CTA does not cover the last CTA on iOS Safari */}
          <div className="h-20 md:hidden" aria-hidden />
        </main>
      </MotionConfig>
      </ReservationProvider>
    </ImagesProvider>
  );
}
